<template>
  <div class="asc-mxrec-attachments-wrapper">
    <h3 v-if="showAttachmentsHeader">ATTACHMENTS</h3>
    <asc-file-upload-input
      v-model="files"
      title="Attachments"
      :accepted-file-properties="fileTypeProperties"
      :on-upload-file="handleMxRecUploadAttachment"
      :on-remove-file="handleMxRecRemoveAttachment"
      :on-download-file="handleMxRecDownloadFile"
      :handle-update-attachment-caption="handleUpdateAttachmentCaption"
      :disabled="false"
      :readonly="
        (isReadOnlyPermissionInvestigate && !isRecommendationTab) || lockEnabled
      "
      :upload-error="mxRecAttachmentError"
      :viewable="true"
      :allow-file-remove="
        !(isReadOnlyPermissionInvestigate && !isRecommendationTab)
      "
      :can-edit-attachment-captions="canEditAttachmentCaptions"
    ></asc-file-upload-input>
  </div>
</template>

<script>
import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'
import AscFileUploadInput from '@/components/molecules/AscFileUploadInput'

export default {
  name: 'AscMxRecAttachmentsWrapper',
  components: {
    AscFileUploadInput,
  },
  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    fileTypeProperties: {
      type: Object,
      default: () => {},
    },
    mxRecAttachmentError: {
      type: Array,
      default: () => [],
    },
    showAttachmentsHeader: {
      type: Boolean,
      default: true,
    },
    handleUpdateAttachmentCaption: {
      type: Function,
      default: () => {},
    },
    canEditAttachmentCaptions: {
      type: Boolean,
      default: false,
    },
    lockEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      flightSenseAttachments: [],
      disabled: false,
    }
  },

  watch: {
    files(newValue) {
      if (newValue.length) {
        this.$nextTick(() => {
          this.flightSenseAttachments = newValue.filter(file =>
            file?.filename.match('FlightSensePO'),
          )
        })
      }
    },
    mxRecAttachmentError(newValue) {
      if (newValue.length) {
        this.flightSenseAttachments = this.flightSenseAttachments.filter(
          item => {
            return item.displayName !== newValue[0]?.name
          },
        )
      }
    },
  },

  methods: {
    handleMxRecUploadAttachment(file) {
      this.$emit('fileUploaded', {
        attachmentTypeId: this.fileTypeProperties.id,
        fileUpload: file,
        isExternallyVisible: true,
      })
    },
    handleMxRecRemoveAttachment(file) {
      this.flightSenseAttachments = this.flightSenseAttachments.filter(
        att => att.displayName !== file.displayName,
      )
      // pending files will not have an id, but will have a file name passed instead
      this.handleRemoveFile(file)
    },
    handleRemoveFile(file) {
      if (Number.isInteger(file?.id)) {
        this.$emit('fileSelected', {
          remove: true,
          id: file.id,
        })
      } else {
        this.$emit('fileSelected', {
          cancel: true,
          file,
        })
      }
    },
    handleMxRecDownloadFile(fileToDownload) {
      this.$emit('downloadFile', fileToDownload)
    },
  },
}
</script>

<style lang="scss">
.asc-mxrec-attachments-wrapper {
  padding: 0 0 16px 0;

  h3 {
    font-size: 14px;
    line-height: $line-height-md;
    color: $primary-black;
    margin-bottom: 10px;
  }

  .asc-autocomplete-selector {
    margin-bottom: 20px;
  }
}
</style>
